import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { ENV } from './env';

export const app = initializeApp(ENV.firebase);
export const auth = getAuth(app);
void setPersistence(auth, browserLocalPersistence);

// Offline-first (roadmap §3.5): reads and queued writes survive no signal; multiple tabs share one cache.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
export const storage = getStorage(app);
export const functions = getFunctions(app);
